import { IRecordAsSeenBy } from 'src/app/common/models/IRecordAsSeenBy';



export class SetRecordAsSeenBy {
    static readonly type = '[IRecordAsSeenBy] Set RecordAsSeenBy Data';

    constructor(public data: IRecordAsSeenBy) {}
}

export class ClearRecordAsSeenBy {
    static readonly type = '[IRecordAsSeenBy] Clear RecordAsSeenBy State';

    constructor() {}
}
